/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * View modes for the video player display.
 * Controls how the player is presented within the application UI.
 */
export enum PlayerViewMode {
  /**
   * Atmospheric mode - player provides ambient background content
   * using the same full-screen dimensions but behind all other UI.
   */
  Atmospheric = "Atmospheric",

  /**
   * Full screen mode - player occupies the entire display.
   */
  FullScreen = "FullScreen",

  /**
   * PIP (Picture-in-Picture) mode - floating window with configurable size and position.
   */
  PIP = "PIP",

  /**
   * PIG (Picture-in-Graphics) mode - fixed position and fixed size within a screen layout.
   */
  PIG = "PIG",

  /**
   * Browser fullscreen mode - uses browser's native fullscreen API (future scope).
   */
  BrowserFullScreen = "BrowserFullScreen",

  /**
   * Hidden mode - the player is paused and completely invisible, but the media
   * source, session and playhead are all retained.
   *
   * Used by screens that have no player surface in their UI (My Hub, Settings,
   * Search, ...). Unlike Atmospheric it never renders and never emits audio;
   * unlike stop()/unmount() it is non-destructive, so claiming any visible view
   * mode again resumes exactly where playback left off.
   */
  Hidden = "Hidden"
}
